import { render } from "./CAwait.vue?vue&type=template&id=296dce1e&scoped=true"
import script from "./CAwait.vue?vue&type=script&lang=js"
export * from "./CAwait.vue?vue&type=script&lang=js"

import "./CAwait.vue?vue&type=style&index=0&id=296dce1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296dce1e"]])

export default __exports__